<template>
  <ims-button
    class="btn btn-icon main-menu-button"
    @click="$store.dispatch('interact/sidemenu/toggle')"
  >
    <ims-icon icon="menu" color="black" />
  </ims-button>
</template>

<script>
export default {};
</script>

<style lang="scss">
</style>
